/* eslint-disable camelcase */
import jwt_decode from 'jwt-decode';
import _split from 'lodash/split';
import { findInList } from '../utils/Tools';

/**
 * Lists
 */
const authPasswordRecoveryLinkErrorsList = [
  {
    key: 'invalid',
    value: 'invalid',
    labelId: 'linkNotFound',
  },
];

const tokenSubjectType = {
  user: 'User',
  booking: 'Booking',
  onDemandAccess: 'OnDemandAccess',
};

/**
 * Utils
 */
const authRecoveryLinkError = (auth) => findInList(authPasswordRecoveryLinkErrorsList, 'value', auth.recoverPassword, 'result');

const getTokenSubject = (token) => {
  try {
    const decoded = jwt_decode(token);
    return decoded.sub;
  } catch (error) {
    return null;
  }
};

const getTokenSubjectType = (tokenSubject) => {
  const allTokenSubjectTypes = Object.values(tokenSubjectType);
  if (tokenSubject) {
    const TOKEN_SUBJECT_SEPARATOR = ':';
    const parts = tokenSubject.split(TOKEN_SUBJECT_SEPARATOR);
    if (parts.length > 0 && allTokenSubjectTypes.some((possibleTokenSubjectType) => possibleTokenSubjectType === parts[0])) {
      return parts[0];
    }
  }
  return null;
};

const getTokenIsUser = (token) => {
  const tokenSubject = getTokenSubject(token);
  if (tokenSubject) {
    return getTokenSubjectType(tokenSubject) === tokenSubjectType.user;
  }
  return false;
};

const getTokenIsOnDemand = (token) => {
  const tokenSubject = getTokenSubject(token);
  if (tokenSubject) {
    return getTokenSubjectType(tokenSubject) === tokenSubjectType.onDemandAccess;
  }
  return false;
};

const getReferenceFromToken = (token) => {
  const subject = getTokenSubject(token);

  if (subject) {
    const parts = _split(subject, ':');
    return parts.length > 0 && parts[1];
  }
  return false;
};

/**
 * GraphQL
 */
const mutDoLogin = `
  mutation Login($input: LoginInput!) {
    login(input: $input) {
      jwt
    }
  }
`;

const mutLoginByMagicLink = `
  mutation LoginByMagicLink($input: LoginByMagicLinkInput!) {
    loginByMagicLink(input: $input) {
      jwt
    }
  }
`;

const mutDoLogout = `
  mutation Logout {
    logout
  }
`;

const mutCreatePasswordRecoveryLink = `
  mutation CreatePasswordRecoveryLinkInput($input: CreatePasswordRecoveryLinkInput!) {
    createPasswordRecoveryLink(input: $input)
  }
`;

const queCheckPasswordRecoveryLink = `
  query CheckPasswordRecoveryLinkInput($input: CheckPasswordRecoveryLinkInput!) {
    checkPasswordRecoveryLink(input: $input)
  }
`;

const mutUsePasswordRecoveryLink = `
  mutation UsePasswordRecoveryLinkInput($input: UsePasswordRecoveryLinkInput!) {
    usePasswordRecoveryLink(input: $input)
  }
`;

const queGetMe = `
  query GetMe {
    me {
      companyName,
      email,
      features,
      firstname,
      id,
      invoiceAddress {
        city,
        country,
        extra,
        street,
        zipCode,
      },
      lastname,
      locale,
      nationalIdentifier,
      paymentMethods {
        brand,
        expMonth,
        expYear,
        last4,
        provider,
        stripeDetails {
          id
        }
      }
      phone
    }
  }
`;

const mutUpdateMe = `
  mutation UpdateMe($input: UpdateMeInput!) {
    updateMe(input: $input) {
      me {
        id
      }
    }
  }
`;

const mutDeleteMyPaymentMethod = `
  mutation mutDeleteMyPaymentMethod($input: DeleteMyPaymentMethodInput!) {
    deleteMyPaymentMethod(input: $input) {
      id
    }
  }
`;

/**
 * Model
 */
const auth = {
  // Name
  name: 'auth',
  tokenSubject: tokenSubjectType,

  // Utils
  recoveryLinkError: authRecoveryLinkError,
  getTokenSubject,
  getTokenSubjectType,
  getTokenIsUser,
  getTokenIsOnDemand,
  getReferenceFromToken,
  // GraphQL
  mutDoLogin,
  mutLoginByMagicLink,
  mutDoLogout,
  queGetMe,
  queCheckPasswordRecoveryLink,
  mutUpdateMe,
  mutCreatePasswordRecoveryLink,
  mutUsePasswordRecoveryLink,
  mutDeleteMyPaymentMethod,
};

module.exports = auth;



// WEBPACK FOOTER //
// ./models/auth.js